import { createFileRoute } from '@tanstack/react-router'

import { LinkCreation } from '@/containers/LinkCreation'

export const Route = createFileRoute('/_unauthenticated/setup/create-link')({
  component: LinkCreation,
})
